var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { Row, Col } from "react-bootstrap";
import { H2 } from "@irati/ui/src/Headings";
import { Label3 } from "@irati/ui/src/Labels";
import Form from "@irati/ui/src/Form";
import Flex from "@irati/ui/src/Flex";
import Description from "@irati-web/fields/companyBenefits/Description";
import ContactInformation from "@irati-web/fields/companyBenefits/ContactInformation";
import ImportantInformation from "@irati-web/fields/companyBenefits/ImportantInformation";
import { CARD, INSTRUCTIONS } from "./Popup";
import H4, { FormSectionHeading } from "./styled/H4";
import Div from "./styled/Div";
import { StyledValidationButton, StyledIconButton } from "./styled/Button";
var DescriptionStep = /** @class */ (function (_super) {
    __extends(DescriptionStep, _super);
    function DescriptionStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DescriptionStep.prototype.render = function () {
        var _a = this.props, show = _a.show, benefit = _a.benefit, onChange = _a.onChange, selectStep = _a.selectStep, formatMessage = _a.formatMessage;
        if (!show) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledIconButton, { onClick: function () {
                    selectStep(CARD);
                }, icon: "backArrow" }),
            React.createElement(Div, null,
                React.createElement(Flex, { direction: "column", alignItems: "center" },
                    React.createElement(Label3, { uppercase: true },
                        React.createElement(FormattedMessage, { id: "admin.components.companyBenefits.description.stepTwo" })),
                    React.createElement(H2, null,
                        React.createElement(FormattedMessage, { id: "admin.components.companyBenefits.description.headerTwo.companyBenefit" })),
                    React.createElement(H2, null,
                        React.createElement(FormattedMessage, { id: "admin.components.companyBenefits.description.headerTwo.description" })),
                    React.createElement(H4, null,
                        React.createElement(FormattedMessage, { id: "admin.components.companyBenefits.description.headerTwo.addInformation" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 12 },
                        React.createElement(Form, { form: "create-company-benefit-step2" },
                            React.createElement(Col, { md: 12 },
                                React.createElement(Description, { benefit: benefit, onChange: onChange }),
                                React.createElement(ContactInformation, { benefit: benefit, onChange: onChange }),
                                React.createElement(FormSectionHeading, null,
                                    React.createElement(FormattedMessage, { id: "admin.components.companyBenefits.description.formSectionHeading.text" })),
                                React.createElement(ImportantInformation, { benefit: benefit, onChange: onChange }))))),
                React.createElement(Flex, { justifyContent: "center" },
                    React.createElement(StyledValidationButton, { primary: true, large: true, loading: formatMessage({ id: "admin.components.companyBenefits.description.validationButton.loading" }), onClick: function () {
                            selectStep(INSTRUCTIONS);
                        } },
                        React.createElement(FormattedMessage, { id: "admin.components.companyBenefits.description.validationButton.continue" }))))));
    };
    return DescriptionStep;
}(Component));
export default injectIntl(DescriptionStep);
